import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../components/Layout'
import SEO from '../components/SEO'

import python from '../../content/images/python.svg'
import javascript from '../../content/images/javascript.svg'


import config from '../utils/config'

const NotesTemplate = ({ data }) => {
  const post = data.markdownRemark

  return (
    <Layout>
      <Helmet title={`${post.frontmatter.title} | ${config.siteTitle}`} />
      <SEO postPath={post.fields.slug} postNode={post} postSEO />
      <section className="md:grid md:grid-cols-10 md:gap-6">
        <aside className="hidden md:block md:col-span-3 sticky self-start top-0 overflow-auto max-h-screen pr-10 pb-64">

          <div className="flex items-center space-x-3 mb-4 mt-2" >
            <img src={post.fields.slug === '/python/' ? python : javascript} width="48" height="auto" alt={post.fields.slug}/>
            <div>
              <div className="text-xl font-serif font-bold leading-tight tracking-widest"> {post.fields.slug === '/python/' ? 'Python' : 'JavaScript'} <br/> Notes</div>
            </div>
          </div>

          <div className="toc" dangerouslySetInnerHTML={{ __html: post.tableOfContents }} />
        </aside>

        <article className="md:col-span-7">
          <div dangerouslySetInnerHTML={{ __html: post.html }} />
        </article>
      </section>
    </Layout>
  )
}

export default NotesTemplate

export const pageQuery = graphql`
  query ProgrammingNotesBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      excerpt
      tableOfContents
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
        thumbnail {
          childImageSharp {
            fixed(width: 150, height: 150) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  }
`
